<div class="image-carousel-component" [ngClass]="{ 'has-edit-button': page?.isPreview() }">
  <!-- CMS Edit Button for Preview Mode -->
  <ng-container
      *ngIf="page?.isPreview()"
      [brManageContentButton]="document"
      documentTemplateQuery="new-ftindia-document"
      folderTemplateQuery="new-ftindia-folder"
      parameter="document"
      [relative]="false"
      root="">
  </ng-container>

  <!-- Component Title -->
  <div class="container" *ngIf="componentTitle">
    <h2 class="component-title text-center mb-4">{{ componentTitle }}</h2>
  </div>

  <!-- Image Carousel Sections -->
  <div class="carousel-sections" *ngIf="imageCarouselSections?.length > 0">
    <div 
      class="carousel-section mb-5" 
      *ngFor="let section of imageCarouselSections; let sectionIndex = index"
      [ngClass]="'text-position-' + getTextPosition(section)">
      
      <div class="carousel-card-container">
        <div class="row align-items-center">
          
          <!-- Text Content - Left Position -->
          <div 
            class="col-lg-6 carousel-text-content" 
            *ngIf="hasTextContent(section) && getTextPosition(section) === 'left'">
            <div class="text-content-wrapper">
              <h3 class="section-title" *ngIf="getTextContent(section)?.title">
                {{ getTextContent(section).title }}
              </h3>
              <div 
                class="section-description" 
                *ngIf="getTextContent(section)?.textContent"
                [innerHTML]="getTextContent(section).textContent?.value || getTextContent(section).textContent">
              </div>
            </div>
          </div>

          <!-- Carousel Images -->
          <div 
            class="carousel-images-wrapper"
            [ngClass]="{
              'col-lg-6': hasTextContent(section),
              'col-12': !hasTextContent(section)
            }">
            
            <div 
              [id]="getCarouselId(sectionIndex)" 
              class="carousel slide image-carousel" 
              [attr.data-bs-ride]="autoplayInterval > 0 ? 'carousel' : null"
              [attr.data-bs-interval]="autoplayInterval > 0 ? autoplayInterval : null">
              
              <!-- Carousel Indicators -->
              <div class="carousel-indicators" *ngIf="showIndicators && getCarouselImages(section)?.length > 1">
                <button 
                  type="button" 
                  *ngFor="let item of getCarouselImages(section); let i = index"
                  [attr.data-bs-target]="getCarouselTarget(sectionIndex)"
                  [attr.data-bs-slide-to]="i"
                  [attr.aria-current]="i === 0"
                  [attr.aria-label]="'Slide ' + (i + 1)"
                  [ngClass]="{ active: i === 0 }">
                </button>
              </div>

              <!-- Carousel Inner -->
              <div class="carousel-inner">
                <div 
                  class="carousel-item" 
                  *ngFor="let carouselItem of getCarouselImages(section); let i = index"
                  [ngClass]="{ active: i === 0 }">
                  
                  <!-- With Link -->
                  <ng-container *ngIf="hasLink(carouselItem); else withoutLink">
                    <a 
                      [href]="getLinkUrl(carouselItem)"
                      [target]="getLinkTarget(carouselItem)"
                      (click)="setAnalytics(carouselItem?.Title || carouselItem?.altTitle)"
                      class="carousel-link">
                      
                      <!-- Desktop Image -->
                      <img 
                        class="d-none d-md-block w-100 carousel-image"
                        [src]="getDesktopImageURL(carouselItem)"
                        [alt]="carouselItem?.Title || carouselItem?.altTitle || 'Carousel Image'">
                      
                      <!-- Mobile Image -->
                      <img 
                        class="d-block d-md-none w-100 carousel-image"
                        [src]="getMobileImageURL(carouselItem)"
                        [alt]="carouselItem?.Title || carouselItem?.altTitle || 'Carousel Image'">
                    </a>
                  </ng-container>

                  <!-- Without Link -->
                  <ng-template #withoutLink>
                    <!-- Desktop Image -->
                    <img 
                      class="d-none d-md-block w-100 carousel-image"
                      [src]="getDesktopImageURL(carouselItem)"
                      [alt]="carouselItem?.Title || carouselItem?.altTitle || 'Carousel Image'">
                    
                    <!-- Mobile Image -->
                    <img 
                      class="d-block d-md-none w-100 carousel-image"
                      [src]="getMobileImageURL(carouselItem)"
                      [alt]="carouselItem?.Title || carouselItem?.altTitle || 'Carousel Image'">
                  </ng-template>

                  <!-- Carousel Caption/Overlay -->
                  <div class="carousel-caption" *ngIf="carouselItem?.Title || carouselItem?.altTitle || carouselItem?.description?.value">
                    <h5 *ngIf="carouselItem?.Title || carouselItem?.altTitle">
                      {{ carouselItem?.Title || carouselItem?.altTitle }}
                    </h5>
                    <div 
                      *ngIf="carouselItem?.description?.value"
                      [innerHTML]="carouselItem.description.value"
                      class="carousel-description">
                    </div>
                    <a 
                      *ngIf="hasLink(carouselItem) && getLinkDisplayText(carouselItem)"
                      [href]="getLinkUrl(carouselItem)"
                      [target]="getLinkTarget(carouselItem)"
                      (click)="setAnalytics(carouselItem?.Title || carouselItem?.altTitle)"
                      class="btn btn-primary carousel-cta">
                      {{ getLinkDisplayText(carouselItem) }}
                    </a>
                  </div>
                </div>
              </div>

              <!-- Carousel Controls -->
              <ng-container *ngIf="showNavigation && getCarouselImages(section)?.length > 1">
                <button 
                  class="carousel-control-prev" 
                  type="button" 
                  [attr.data-bs-target]="getCarouselTarget(sectionIndex)"
                  data-bs-slide="prev"
                  [attr.aria-label]="'Previous slide'">
                  <i class="bi bi-arrow-left-short" aria-hidden="true"></i>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button 
                  class="carousel-control-next" 
                  type="button" 
                  [attr.data-bs-target]="getCarouselTarget(sectionIndex)"
                  data-bs-slide="next"
                  [attr.aria-label]="'Next slide'">
                  <i class="bi bi-arrow-right-short" aria-hidden="true"></i>
                  <span class="visually-hidden">Next</span>
                </button>
              </ng-container>
            </div>
          </div>

          <!-- Text Content - Right Position -->
          <div 
            class="col-lg-6 carousel-text-content" 
            *ngIf="hasTextContent(section) && getTextPosition(section) === 'right'">
            <div class="text-content-wrapper">
              <h3 class="section-title" *ngIf="getTextContent(section)?.title">
                {{ getTextContent(section).title }}
              </h3>
              <div 
                class="section-description" 
                *ngIf="getTextContent(section)?.textContent"
                [innerHTML]="getTextContent(section).textContent?.value || getTextContent(section).textContent">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Fallback message when no sections exist -->
  <div class="container text-center py-5" *ngIf="!imageCarouselSections?.length">
    <p class="text-muted">No carousel sections configured.</p>
  </div>
</div>